import type { Component, InjectionKey, Ref } from 'vue';

/**
 * ReturnType for a function that can return either a value or a `Promise` with that value
 */
type Awaitable<T> = PromiseLike<T> | T;

/** The `IconComponent` type is used as type hint for components from the `@blpde/nx-icons` package. */
type IconComponent = Component<{ $props: { filled?: boolean; size?: string; color?: string } }>;

const debounce = <T extends unknown[]>(fn: (...args: T) => void, wait: number) => {
  let timer: ReturnType<typeof setTimeout>;
  return function (...args: T) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, wait);
  };
};

/** The `i18nInjectionKey` is provided by the application using this UI package */
const i18nInjectionKey = Symbol() as InjectionKey<{
  /** Locale message translation */
  t: (key: string, ...args: unknown[]) => string;
  /** Datetime formatting (for now only the format "short" is supported) */
  d: (value: Date, format: 'short') => string;
  /** The current locale of the application. */
  locale: Ref<string>;
}>;

export { debounce, i18nInjectionKey };
export type { Awaitable, IconComponent };
